import { useMutation, useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  AcceptIcon,
  ArrowDownBlueIcon,
  ProposeChangeIcon,
  RejectIcon,
} from '../../../Components/icons/icons';
import ListingStatus from '../../../Components/listing-status/listing-status';
import NoData from '../../../Components/no-data/no-data';
import PanelCard from '../../../Components/panel-card/panel-card';
import BesicTable from '../../../Components/table/basicTable';
import CustomTable from '../../../Components/table/table';
import QUERY_ORDER_DETAILS, {
  UPDATE_ORDERITEMS,
} from '../../../graphQL/orderDetailsPage';
import './details-listing.scss';
import Button from '../../../Components/button/button';
import NewButton from '../../../Components/button/newButton';
import { giveProfile } from '../../../Components/global-notification/notification-list';
import { CalenderEditIcon } from '../../../Components/icons/filter-icons';
import Action from '../../../Components/action/action';
import { RadioButton } from '../../../Components/radio-button/radio-button';
import Dialog from '../../../Components/dialog/dialog';
import PerformBulkActions from '../../../Components/perform-bulk-action/bulk-actions';
import { MenuOrders } from '../../../Components/icons/left-menu';
import useDialog from '../../../Components/dialog/useDialog';
import { Refresh } from '../../../Components/icons/comments-icon';
import IconButton from '../../../Components/icon-button/icon-button';
import DialogPanel from '../../../Components/dialog-panel/dialog-panel';
import DialogPanelBody from '../../../Components/dialog-panel/dialog-panel-body/dialog-panel-body';
import DatepickerBox from '../../../Components/datepicker-box/datepicker-box';
import DialogPanelFooter from '../../../Components/dialog-panel/dialog-panel-footer/dialog-panel-footer';
import menuSchema from '../../../schema/menuSchema';
import { checkPermission } from '../../../helpers/permissionHelper';

function DetailsListing({
  title,
  data,
  columns,
  activeButtons,
  acceptClick,
  rejectClick,
  proposeClick,
  defaultClick,
  defaultButton,
  disableDefaultButton,
  sendData,
  eventAction,
  isCheckBoxRequired,
  lineItemIdSelected,
  emptyArrayflag,
  boolVal,
  poItemCodeArray,
  hideDefault,
  showEventButtons,
  className,
  setRequestAdditionalFunds,
  requestadditionalfundbutton,
  approveaddtionalexpenselabel,
  setapproveaddtionalexpense,
  approvalbutton,
  viewapproveexpensebutton,
  requestSendForApprovalbtn,
  verifyDocumentslabel,
  toggleVerfiydocuments,
  RequestR1buttonflag,
  deleteMessage,
  disableCustomClearButton,
  isCustoms,
  subTitle,
  hideSubtitle,
  showCustomsButton,
  toggleConsolidateCustoms,
  titleClass,
  headerClass,
  activeEmailApproval,
  handleEmailApproval,
  disableEmailApproval,
  handleSendrates,
  sendRateLabel,
  enableReset,
  selectedBulkItemId,
  setSelectedBulkAction,
  selectedBulkAction,
}) {
  const [t] = useTranslation('manageorders');
  const [t2] = useTranslation('manageshipments');
  const [t3] = useTranslation('toast');
  const language = localStorage.getItem('language');
  const { poId, bookingId, id } = useParams();
  const { relation } = useParams();
  const { bulkActionSchema } = menuSchema();
  const { bulkActionOptionsDetails } = bulkActionSchema();
  const [bulkCargoDate, setBulkCargoDate] = useState(new Date());

  // RESET BULK ACTION WHEN NO ITEMS SELECTED
  useEffect(() => {
    if (selectedBulkItemId?.length === 0) {
      setSelectedBulkAction('');
      setBulkCargoDate(new Date());
    }
  }, [selectedBulkItemId]);

  const {
    isShowing: togglePerformBulkAction,
    toggle: handlePerformBulkAction,
  } = useDialog();

  const {
    isShowing: toggleConfirmCargoReady,
    toggle: handleToggleConfirmCargoReady,
  } = useDialog();

  const [handleUpdateOrderItem, { loading: isOrderItemLoading }] =
    useMutation(UPDATE_ORDERITEMS);
  const { refetch } = useQuery(
    QUERY_ORDER_DETAILS,
    {
      variables: {
        input: {
          id: poId,
          profileType: giveProfile(relation),
          // poNumber: poData.PODetails.data[0].poNumber,
        },
      },
      skip: true,
      notifyOnNetworkStatusChange: true,
    },
    { enabled: false }
  );

  const checkChannelType = (chnid) => {
    let chnType;
    switch (chnid) {
      case poId:
        chnType = 'order';
        break;
      case bookingId:
        chnType = 'booking';
        break;
      case id:
        chnType = 'shipment';
        break;
      default:
        break;
    }
    return chnType;
  };

  const handleSubmit = (value) => {
    handleUpdateOrderItem({
      variables: {
        input: {
          id: poId || bookingId || id,
          module: checkChannelType(poId || bookingId || id),
          lineItemId: selectedBulkItemId,
          profileType: giveProfile(relation),
          statusName: selectedBulkAction?.detailsvalue || value?.detailsvalue,
          statusDate: bulkCargoDate || new Date(),
        },
      },
      onCompleted: (datas) => {
        toast.success(datas?.updateOrderItem?.message);
        setSelectedBulkAction('');
        setBulkCargoDate(new Date());
        refetch();
      },
      onError: () => {
        setSelectedBulkAction('');
        setBulkCargoDate(new Date());
        refetch();
      },
    });
  };

  const handleRadioChange = (value) => {
    setSelectedBulkAction(value);
    switch (value?.detailsvalue) {
      case 'Accepted':
        acceptClick();
        break;

      case 'Cargo Ready':
        handleToggleConfirmCargoReady();
        break;

      default:
        handleSubmit(value);
    }
  };

  return (
    <div className="details-listing-container">
      {title !== '' && (
        <div className={`details-listing-header align-center ${headerClass}`}>
          <div className="d-block">
            <h3 className={`title ${titleClass}`}>{title}</h3>
            {subTitle && !hideSubtitle && (
              <div className="details-listing-subtitle">
                <p>{subTitle}</p>
              </div>
            )}
          </div>

          <div className="button-section">
            {approvalbutton ? (
              <NewButton
                className="propose"
                onClick={setapproveaddtionalexpense}
              >
                {approveaddtionalexpenselabel}
              </NewButton>
            ) : (
              viewapproveexpensebutton && (
                <NewButton
                  className="propose"
                  onClick={setapproveaddtionalexpense}
                >
                  {approveaddtionalexpenselabel}
                </NewButton>
              )
            )}
            {requestSendForApprovalbtn && (
              <NewButton
                className="propose"
                onClick={setRequestAdditionalFunds}
              >
                {requestadditionalfundbutton}
              </NewButton>
            )}
            {RequestR1buttonflag && (
              <NewButton className="propose" onClick={toggleVerfiydocuments}>
                {verifyDocumentslabel}
              </NewButton>
            )}

            {showCustomsButton && (
              <NewButton className="propose" onClick={toggleConsolidateCustoms}>
                {t2(
                  'manageshipmentsscreen.shipmentdetails.customsclearancebtn.finshCustomsbtn'
                )}
              </NewButton>
            )}
            {!hideDefault &&
              !disableDefaultButton &&
              defaultButton !== '' &&
              !disableCustomClearButton && (
                <NewButton className="propose" onClick={defaultClick}>
                  {defaultButton}
                </NewButton>
              )}
            {defaultButton ===
              t2(
                'manageshipmentsscreen.shipmentdetails.customsclearancebtn.titlebtn'
              ) &&
              disableCustomClearButton && (
                <NewButton className="disabled" disabled>
                  {defaultButton}
                </NewButton>
              )}

            {activeButtons && (
              <>
                {showEventButtons &&
                  eventAction.Accept &&
                  giveProfile(relation) === 'buyer' &&
                  !checkPermission(
                    giveProfile(relation),
                    'Supplier Role',
                    'Milestone update'
                  ) &&
                  checkPermission(
                    giveProfile(relation),
                    'Order',
                    'Milestone update'
                  ) && (
                    <button
                      type="button"
                      className="accept"
                      onClick={acceptClick}
                    >
                      <AcceptIcon /> {t('manageordersscreen.acceptpopup.title')}
                    </button>
                  )}
                {eventAction?.Reject && (
                  <button
                    type="button"
                    className="reject"
                    onClick={rejectClick}
                  >
                    <RejectIcon /> {t('manageordersscreen.rejectpopup.decline')}
                  </button>
                )}
                {eventAction?.SendRate && (
                  <NewButton className="propose" onClick={handleSendrates}>
                    {sendRateLabel}
                  </NewButton>
                )}
                {eventAction?.ProposeChange && (
                  <NewButton className="propose" onClick={proposeClick}>
                    <ProposeChangeIcon />
                    {t('manageordersscreen.proposechanges.title')}
                  </NewButton>
                  // <Button className="propose" onClick={proposeClick}>
                  //   <ProposeChangeIcon />
                  //   Propose Changes
                  // </Button>
                )}
                {/* ----------  Perform Bulk Action ---------- */}
                {
                  showEventButtons && eventAction?.bulkBookingDetails && (
                    // (!selectedBulkAction ? (
                    <Action
                      label={t('manageordersscreen.performBulkAction.action')}
                      className="actions-btn no-hover"
                      closeOnclick={true}
                      zIndex={999999}
                      containerClass="po-action-list-item"
                      icon={<ArrowDownBlueIcon />}
                      disabled={selectedBulkItemId?.length === 0}
                      placement="self-bottom"
                    >
                      {bulkActionOptionsDetails
                        ?.filter((action) => action?.detailsvalue)
                        .map((action) => (
                          <>
                            {false && (
                              <RadioButton
                                key={action.value}
                                name={action.name}
                                value={action.detailsvalue}
                                checked={
                                  selectedBulkAction?.detailsvalue ===
                                  action.detailsvalue
                                }
                                onChange={() => handleRadioChange(action)}
                                className="radio-button-individual"
                                hideCircle={true}
                              >
                                {action.label?.[language] || ''}
                              </RadioButton>
                            )}
                            <button
                              type="button"
                              onClick={() => handleRadioChange(action)}
                            >
                              {action.label?.[language] || ''}
                            </button>
                          </>
                        ))}
                    </Action>
                  )
                  // ) : (

                  // ))
                }
                {false && (
                  <div className="button-group">
                    <NewButton
                      styles="outline"
                      // onClick={handlePerformBulkAction}
                      onClick={() => {
                        if (selectedBulkAction?.detailsvalue === 'Accepted') {
                          acceptClick();
                        } else if (
                          selectedBulkAction?.detailsvalue === 'Cargo Ready'
                        ) {
                          handleToggleConfirmCargoReady();
                        } else {
                          handleSubmit();
                        }
                      }}
                      id="performBulkActionBtn"
                      color="transparent"
                      className="actions-btn"
                    >
                      <MenuOrders
                        color="#2179C4"
                        width="1.111vw"
                        height="1.111vw"
                      />
                      {bulkActionOptionsDetails?.find(
                        (a) =>
                          a?.detailsvalue === selectedBulkAction?.detailsvalue
                      )?.label?.[language] ||
                        t('manageordersscreen.performBulkAction.title')}
                    </NewButton>

                    {enableReset && (
                      <IconButton
                        verient="transparent"
                        onClick={() => setSelectedBulkAction('')}
                        id="reset"
                      >
                        <Refresh
                          color="#2179C4"
                          width="1.111vw"
                          height="1.111vw"
                        />
                      </IconButton>
                    )}
                  </div>
                )}
              </>
            )}

            {/* Accept/Reject Quotation for  Email Approval */}
            {activeEmailApproval && (
              <>
                <button
                  type="button"
                  className="accept"
                  onClick={() => handleEmailApproval('Accepted')}
                  disabled={disableEmailApproval}
                >
                  <AcceptIcon /> {t('manageordersscreen.acceptpopup.title')}
                </button>

                <button
                  type="button"
                  className="reject"
                  onClick={() => handleEmailApproval('Rejected')}
                  disabled={disableEmailApproval}
                >
                  <RejectIcon /> {t('manageordersscreen.rejectpopup.title')}
                </button>
              </>
            )}
          </div>
        </div>
      )}

      <div className="details-listing-body">
        <PanelCard noSpacing noShadow={title === ''}>
          <div>
            {(data && data?.length === 0) || data?.length === undefined ? (
              <NoData />
            ) : (
              <div>
                {!isCheckBoxRequired ? (
                  <BesicTable
                    columns={columns}
                    data={data}
                    getChildData={(x, isChecked) => {
                      sendData(x, isChecked);
                    }}
                    className={`auto-column-width ${className}`}
                  />
                ) : (
                  <CustomTable
                    emptyArrayflag={emptyArrayflag}
                    boolVal={boolVal}
                    poItemCodeArray={poItemCodeArray}
                    lineItemIdSelected={lineItemIdSelected}
                    columns={columns}
                    data={data}
                    getChildData={(x, isChecked) => {
                      sendData(x, isChecked);
                    }}
                    isCheckBoxRequired={isCheckBoxRequired}
                    className={className}
                    deleteMessage={deleteMessage}
                    isCustoms={isCustoms}
                  />
                )}
              </div>
            )}
          </div>
        </PanelCard>
      </div>
      <Dialog
        placement="center"
        isShowing={togglePerformBulkAction}
        hide={() => handlePerformBulkAction()}
      >
        <div className="pt-5">
          <PerformBulkActions
            translate={t}
            // handleSubmit={acceptClick}
            onCancelClick={() => handlePerformBulkAction()}
          />
        </div>
      </Dialog>
      <Dialog
        isShowing={toggleConfirmCargoReady}
        hide={() => {
          setBulkCargoDate(new Date());
          handleToggleConfirmCargoReady();
        }}
        placement="center"
      >
        <DialogPanel title={t('manageordersscreen.cargoreadyconfirm.title')}>
          <DialogPanelBody>
            <p>
              {selectedBulkItemId?.length > 1
                ? t('manageordersscreen.cargoreadyconfirm.description_plural', {
                    count: new Set(selectedBulkItemId || [])?.size,
                  })
                : t('manageordersscreen.cargoreadyconfirm.description', {
                    count: new Set(selectedBulkItemId || [])?.size,
                  })}
            </p>
            <DatepickerBox
              selectedDate={bulkCargoDate}
              label={t('manageordersscreen.bulkconsolidatecargo.enterdate')}
              onChange={(e) => {
                if (e <= new Date()) {
                  setBulkCargoDate(e);
                } else {
                  toast.error(t3('buyer.error.pastdatedcargo'));
                }
              }}
              required
            />
          </DialogPanelBody>
          <DialogPanelFooter>
            <Button
              label={t('manageordersscreen.cargoreadyconfirm.no')}
              type="button"
              onClick={() => {
                setBulkCargoDate(new Date());
                handleToggleConfirmCargoReady();
              }}
              // className="reject"
              styles="cancel"
            />
            <Button
              label={t('manageordersscreen.cargoreadyconfirm.yes')}
              type="button"
              disabled={isOrderItemLoading}
              onClick={() => {
                handleSubmit();
                handleToggleConfirmCargoReady();
              }}
              styles="submit"
            />
          </DialogPanelFooter>
        </DialogPanel>
      </Dialog>
    </div>
  );
}
export default React.memo(DetailsListing);
DetailsListing.propTypes = {
  title: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.string).isRequired,
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  eventAction: PropTypes.instanceOf(Object),
  lineItemIdSelected: PropTypes.instanceOf(Array),
  acceptClick: PropTypes.func,
  emptyArrayflag: PropTypes.number,
  rejectClick: PropTypes.func,
  proposeClick: PropTypes.func,
  handleSendrates: PropTypes.func,
  setRequestAdditionalFunds: PropTypes.func,
  setapproveaddtionalexpense: PropTypes.func,
  defaultClick: PropTypes.func,
  activeButtons: PropTypes.bool,
  boolVal: PropTypes.bool,
  defaultButton: PropTypes.string,
  sendData: PropTypes.func,
  poItemCodeArray: PropTypes.instanceOf(Array),
  isCheckBoxRequired: PropTypes.bool,
  disableDefaultButton: PropTypes.bool,
  hideDefault: PropTypes.bool,
  showEventButtons: PropTypes.bool,
  className: PropTypes.string,
  requestadditionalfundbutton: PropTypes.string,
  approveaddtionalexpenselabel: PropTypes.string,
  approvalbutton: PropTypes.bool,
  viewapproveexpensebutton: PropTypes.bool,
  requestSendForApprovalbtn: PropTypes.bool,
  toggleVerfiydocuments: PropTypes.func,
  verifyDocumentslabel: PropTypes.string,
  RequestR1buttonflag: PropTypes.bool,
  deleteMessage: PropTypes.string,
  sendRateLabel: PropTypes.string,
  disableCustomClearButton: PropTypes.bool,
  isCustoms: PropTypes.bool,
  subTitle: PropTypes.string,
  hideSubtitle: PropTypes.bool,
  showCustomsButton: PropTypes.bool,
  toggleConsolidateCustoms: PropTypes.func,
  titleClass: PropTypes.string,
  headerClass: PropTypes.string,
  activeEmailApproval: PropTypes.bool,
  handleEmailApproval: PropTypes.func,
  disableEmailApproval: PropTypes.bool,
  enableReset: PropTypes.bool,
  selectedBulkItemId: PropTypes.instanceOf(Array),
  setSelectedBulkAction: PropTypes.func,
  selectedBulkAction: PropTypes.string,
};
DetailsListing.defaultProps = {
  title: '',
  defaultButton: '',
  sendRateLabel: '',
  requestadditionalfundbutton: '',
  approveaddtionalexpenselabel: '',
  emptyArrayflag: 0,
  poItemCodeArray: [],
  eventAction: {},
  activeButtons: false,
  lineItemIdSelected: [],
  sendData: () => {},
  handleSendrates: () => {},
  acceptClick: () => {},
  rejectClick: () => {},
  proposeClick: () => {},
  defaultClick: () => {},
  setRequestAdditionalFunds: () => {},
  setapproveaddtionalexpense: () => {},
  isCheckBoxRequired: false,
  boolVal: false,
  disableDefaultButton: false,
  hideDefault: false,
  showEventButtons: true,
  className: '',
  approvalbutton: false,
  viewapproveexpensebutton: false,
  requestSendForApprovalbtn: false,
  toggleVerfiydocuments: false,
  verifyDocumentslabel: '',
  RequestR1buttonflag: false,
  deleteMessage: '',
  disableCustomClearButton: false,
  isCustoms: false,
  subTitle: '',
  hideSubtitle: false,
  showCustomsButton: false,
  toggleConsolidateCustoms: () => {},
  titleClass: '',
  headerClass: '',
  activeEmailApproval: false,
  handleEmailApproval: () => {},
  disableEmailApproval: false,
  enableReset: false,
  selectedBulkItemId: [],
  setSelectedBulkAction: () => {},
  selectedBulkAction: '',
};

export function DropDownSts({
  statusLabel,
  enableDropdown,
  futureStatus,
  lineItem,
}) {
  const { poId, bookingId, id } = useParams();
  const [handleUpdateOrderItem] = useMutation(UPDATE_ORDERITEMS);
  const { relation } = useParams();
  const { refetch } = useQuery(
    QUERY_ORDER_DETAILS,
    {
      variables: {
        input: {
          id: poId,
          profileType: giveProfile(relation),
          // poNumber: poData.PODetails.data[0].poNumber,
        },
      },
      skip: true,
      notifyOnNetworkStatusChange: true,
    },
    { enabled: false }
  );

  const checkChannelType = (chnid) => {
    let chnType;
    switch (chnid) {
      case poId:
        chnType = 'order';
        break;
      case bookingId:
        chnType = 'booking';
        break;
      case id:
        chnType = 'shipment';
        break;
      default:
        break;
    }
    return chnType;
  };

  const handleSubmit = (ip) => {
    handleUpdateOrderItem({
      variables: {
        input: {
          id: poId || bookingId || id,
          module: checkChannelType(poId || bookingId || id),
          lineItemId: [lineItem._id],
          profileType: giveProfile(relation),
          ...ip,
        },
      },
      onCompleted: (data) => {
        toast.success(data?.updateOrderItem?.message);
        refetch();
      },
    });
  };

  return (
    <ListingStatus
      statusLabel={statusLabel}
      enableDropdown={enableDropdown}
      futureStatus={futureStatus}
      handleSubmit={handleSubmit}
      item={lineItem}
      icon={<CalenderEditIcon />}
    />
  );
}
DropDownSts.propTypes = {
  statusLabel: PropTypes.string,

  lineItem: PropTypes.string,
  enableDropdown: PropTypes.bool,
  futureStatus: PropTypes.instanceOf(Array),
};
DropDownSts.defaultProps = {
  statusLabel: '',
  lineItem: '',
  enableDropdown: false,
  futureStatus: [],
};
